export const SUGGEST_WHITEBOARD_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS = {
	hasDismissedFlowChart: 'suggest-whiteboard-based-on-page-title:hasDismissedFlowChart',
	hasDismissedBrainstorming: 'suggest-whiteboard-based-on-page-title:hasDismissedBrainstorming',
	hasDismissedRetro: 'suggest-whiteboard-based-on-page-title:hasDismissedRetro',
	hasDismissedIncidentPostmortem:
		'suggest-whiteboard-based-on-page-title:hasDismissedIncidentPostmortem',
	hasDismissedProductRoadmap: 'suggest-whiteboard-based-on-page-title:hasDismissedProductRoadmap',
	hasDismissedPrioritizationMatrix:
		'suggest-whiteboard-based-on-page-title:hasDismissedPrioritizationMatrix',
	hasDismissedIcebreakers: 'suggest-whiteboard-based-on-page-title:hasDismissedIcebreakers',
	hasDismissedOrgChart: 'suggest-whiteboard-based-on-page-title:hasDismissedOrgChart',
	hasDismissedStickyNotePack: 'suggest-whiteboard-based-on-page-title:hasDismissedStickyNotePack',
	hasDismissedAllTemplateSuggestions:
		'suggest-whiteboard-based-on-page-title:hasDismissedAllTemplateSuggestions',
} as const;

export const SuggestWhiteboardBasedOnPageTitleOnboardingKeys = [
	...Object.values(SUGGEST_WHITEBOARD_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS),
] as const;
